var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.683 17.394L28.803 17.155C28.648 16.678 28.457 16.218 28.234 15.781L29.395 14.286C29.865 13.681 29.81 12.827 29.273 12.307L27.698 10.732C27.173 10.19 26.319 10.136 25.713 10.605L24.22 11.766C23.783 11.543 23.323 11.352 22.845 11.197L22.606 9.32C22.516 8.567 21.877 8 21.12 8H18.88C18.123 8 17.484 8.567 17.394 9.317L17.155 11.197C16.677 11.352 16.217 11.542 15.78 11.766L14.286 10.605C13.682 10.136 12.828 10.19 12.307 10.727L10.732 12.301C10.19 12.827 10.135 13.681 10.605 14.287L11.766 15.781C11.542 16.218 11.352 16.678 11.197 17.155L9.32 17.394C8.567 17.484 8 18.123 8 18.88V21.12C8 21.877 8.567 22.516 9.317 22.606L11.197 22.845C11.352 23.322 11.543 23.782 11.766 24.219L10.605 25.714C10.135 26.319 10.19 27.173 10.727 27.693L12.302 29.268C12.828 29.809 13.681 29.863 14.287 29.394L15.781 28.233C16.218 28.457 16.678 28.648 17.155 28.802L17.394 30.678C17.484 31.433 18.123 32 18.88 32H21.12C21.877 32 22.516 31.433 22.606 30.683L22.845 28.803C23.322 28.648 23.782 28.457 24.219 28.234L25.714 29.395C26.319 29.865 27.173 29.81 27.693 29.273L29.268 27.698C29.81 27.172 29.865 26.319 29.395 25.713L28.234 24.219C28.458 23.782 28.649 23.322 28.803 22.845L30.679 22.606C31.432 22.516 31.999 21.877 31.999 21.12V18.88C32 18.123 31.433 17.484 30.683 17.394ZM20 25C17.243 25 15 22.757 15 20C15 17.243 17.243 15 20 15C22.757 15 25 17.243 25 20C25 22.757 22.757 25 20 25Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.d24493f4f26c6b3b49566ee10c06aabe.svg";
export { ForwardRef as ReactComponent };